import axios from 'axios';

const backendBaseUrl = process.env.REACT_APP_BACKEND_URL;

let allCategories = null;

async function fetchCategories() {
    try {
        const response = await axios.get(backendBaseUrl + "productCategories/");
        allCategories = response.data;
    }
    catch (error) {
        console.log(error);
        allCategories = [];
    }
}

async function getAllCategories() {
    if (allCategories == null) {
        await fetchCategories();
    }

    allCategories.sort((a, b) => a.orderId - b.orderId);

    return allCategories;
}

async function getAllCategoryIds() {
    if (allCategories == null) {
        await fetchCategories();
    }

    let allCategoryIds = allCategories.map((category) => category.id);
    return allCategoryIds;
}

export { getAllCategories, getAllCategoryIds}